<template>
  <div>
    <div class="toolbar">
      <el-input v-model="keyword" clearable placeholder="单号/标题/客户" style="width:220px" @keyup.enter.native="load" />
      <el-select v-model="status" clearable placeholder="状态" style="width:140px" @change="load">
        <el-option label="待办（未办结）" value="PENDING" />
        <el-option label="待处理" value="OPEN" />
        <el-option label="处理中" value="PROCESSING" />
        <el-option label="已完成" value="DONE" />
        <el-option label="已关闭" value="CLOSED" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
    </div>
    <el-table :data="list" border stripe v-loading="loading">
      <el-table-column prop="ticketNo" label="单号" width="170" />
      <el-table-column prop="title" label="标题" min-width="140" />
      <el-table-column prop="projectName" label="项目" min-width="120" />
      <el-table-column prop="customerPhone" label="电话" width="120" />
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="{ row }">{{ statusText(row.status) }}</template>
      </el-table-column>
      <el-table-column prop="createdAt" label="提交时间" width="170" />
      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="open(row)">处理</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="售后处理" :visible.sync="visible" width="720px" @closed="onClosed">
      <div v-loading="detailLoading">
        <el-form v-if="current" label-width="96px" class="detail-form">
          <el-divider content-position="left">客户提交信息</el-divider>
          <el-row :gutter="12">
            <el-col :span="12">
              <el-form-item label="单号">{{ current.ticketNo || '-' }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态">{{ statusText(current.status) }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="项目">{{ current.projectName || '-' }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="提交时间">{{ current.createdAt || '-' }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户">{{ current.customerName || '-' }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电话">{{ current.customerPhone || '-' }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="提交人">{{ current.createdByName || '-' }}</el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="标题">{{ current.title || '-' }}</el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="问题描述">
                <div class="content-box">{{ current.content || '-' }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="提交图片">
                <div v-if="(current.attachments || []).length" class="photo-list">
                  <el-image
                    v-for="(a, i) in current.attachments"
                    :key="a.id || i"
                    class="photo"
                    :src="a.url"
                    :preview-src-list="customerPreviewList"
                    fit="cover"
                  />
                </div>
                <span v-else class="muted">无</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-divider content-position="left">处理回复</el-divider>
          <el-form-item label="处理状态">
            <el-select v-model="form.status" style="width:220px">
              <el-option label="待处理" value="OPEN" />
              <el-option label="处理中" value="PROCESSING" />
              <el-option label="已完成" value="DONE" />
              <el-option label="已关闭" value="CLOSED" />
            </el-select>
          </el-form-item>
          <el-form-item label="处理说明">
            <el-input v-model="form.handleRemark" type="textarea" :rows="4" placeholder="填写处理说明" />
          </el-form-item>
          <el-form-item label="处理图片">
            <el-upload
              action="#"
              :http-request="elUploadHttpRequest"
              list-type="picture-card"
              accept="image/*"
              :file-list="fileList"
              :limit="9"
              :on-success="onUploadSuccess"
              :on-remove="onUploadRemove"
              :on-preview="onUploadPreview"
              :before-upload="beforeUpload"
            >
              <i class="el-icon-plus" />
            </el-upload>
            <div class="hint">最多 9 张</div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" :loading="saving" :disabled="detailLoading || !current" @click="save">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="previewVisible" append-to-body width="auto">
      <img v-if="previewUrl" :src="previewUrl" class="preview-img" alt="预览" />
    </el-dialog>
  </div>
</template>

<script>
import { listAfterSales, getAfterSale, handleAfterSale } from '../../api/service'
import { elUploadHttpRequest } from '../../utils/ossUpload'

export default {
  name: 'AfterSale',
  data() {
    return {
      list: [],
      loading: false,
      detailLoading: false,
      saving: false,
      keyword: '',
      status: '',
      visible: false,
      current: null,
      form: { status: 'DONE', handleRemark: '' },
      fileList: [],
      previewVisible: false,
      previewUrl: ''
    }
  },
  computed: {
    customerPreviewList() {
      return ((this.current && this.current.attachments) || []).map(a => a.url).filter(Boolean)
    }
  },
  created() {
    if (this.$route.query.status) this.status = this.$route.query.status
    this.load()
  },
  methods: {
    elUploadHttpRequest,
    statusText(s) {
      return ({ OPEN: '待处理', PROCESSING: '处理中', DONE: '已完成', CLOSED: '已关闭' }[s]) || s
    },
    async load() {
      this.loading = true
      try {
        const res = await listAfterSales({
          keyword: this.keyword || undefined,
          status: this.status || undefined
        })
        this.list = res.data || []
      } finally {
        this.loading = false
      }
    },
    async open(row) {
      this.visible = true
      this.detailLoading = true
      this.current = null
      this.fileList = []
      try {
        const res = await getAfterSale(row.id)
        const detail = res.data || {}
        this.current = detail
        this.form = {
          status: detail.status === 'OPEN' ? 'PROCESSING' : (detail.status || 'DONE'),
          handleRemark: detail.handleRemark || ''
        }
        this.fileList = (detail.handleAttachments || []).map(a => ({
          name: a.fileName || ('img-' + a.id),
          url: a.url,
          response: { data: a },
          uid: a.id
        }))
      } catch (e) {
        this.visible = false
      } finally {
        this.detailLoading = false
      }
    },
    onClosed() {
      this.current = null
      this.fileList = []
      this.previewUrl = ''
      this.previewVisible = false
    },
    beforeUpload(file) {
      const ok = /^image\//.test(file.type)
      if (!ok) this.$message.error('只能上传图片')
      return ok
    },
    onUploadSuccess(res, file, fileList) {
      const data = res && res.data
      if (!data || !data.id) {
        this.$message.error((res && res.message) || '上传失败')
        this.fileList = fileList.filter(f => f.uid !== file.uid)
        return
      }
      file.url = data.url
      file.response = { data }
      this.fileList = fileList
    },
    onUploadRemove(file, fileList) {
      this.fileList = fileList
    },
    onUploadPreview(file) {
      this.previewUrl = file.url
      this.previewVisible = true
    },
    collectAttachmentIds() {
      return (this.fileList || []).map(f => {
        const d = f.response && f.response.data
        return (d && d.id) || f.uid
      }).filter(id => id != null)
    },
    async save() {
      if (!this.current) return
      this.saving = true
      try {
        await handleAfterSale(this.current.id, {
          status: this.form.status,
          handleRemark: this.form.handleRemark,
          attachmentIds: this.collectAttachmentIds()
        })
        this.$message.success('已更新')
        this.visible = false
        this.load()
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.detail-form >>> .el-form-item {
  margin-bottom: 12px;
}
.content-box {
  white-space: pre-wrap;
  line-height: 1.6;
  color: #303133;
  word-break: break-word;
}
.photo-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.photo {
  width: 88px;
  height: 88px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}
.muted { color: #909399; }
.hint { margin-top: 6px; color: #909399; font-size: 12px; }
.preview-img { max-width: 80vw; max-height: 80vh; display: block; }
</style>
